<div class="wudo-slide-panel" [@.disabled]="!animationEnabled" [@slide]="activePanelPosition">
    <div class="panel"><ng-content select="[centerPanel]"></ng-content></div>
    <div class="panel"><ng-content select="[rightPanel]"></ng-content></div>
</div>
